import { faGavel } from '@fortawesome/pro-solid-svg-icons';
import { ChangeEvent } from 'react';
import { useInstantSearch, useToggleRefinement } from 'react-instantsearch';
import { useIntl } from 'react-intl';

import { Text16 } from '@sorare/core/src/atoms/typography';
import Switch from '@sorare/core/src/components/search/Switch';
import useEvents from '@sorare/core/src/lib/events/useEvents';
import { FilterWidget, TOGGLE_FILTERS } from '@sorare/core/src/lib/filters';

import { useCurrentMarketplaceUserContext } from 'contexts/currentMarketplaceUser';
import { Toggle } from 'searchCards/Toggle';

const FILTER = TOGGLE_FILTERS.myAuctionsFilter;

const Filter = () => {
  const { formatMessage } = useIntl();
  const { involvedLiveTokenAuctions } = useCurrentMarketplaceUserContext();
  const { indexUiState } = useInstantSearch();
  const track = useEvents();
  const {
    refine,
    value: { isRefined },
  } = useToggleRefinement({
    attribute: FILTER.attribute,
    on: involvedLiveTokenAuctions.nodes.flatMap(auction =>
      auction.anyCards.map(card => card.slug)
    ),
  });

  if (!involvedLiveTokenAuctions.nodes.length) return null;

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    track('Use Market Filter', {
      filterName: FILTER.attribute,
      filterValue: event.target.checked.toString(),
    });

    refine({ isRefined });
  };

  // we rather consider the refinement state from the UI
  // so that we don't rely on the Algolia answer to come back to reflect the slider state
  const optimisticRefined = !!indexUiState.toggle?.[FILTER.attribute];

  return (
    <Toggle icon={faGavel}>
      <Switch
        checked={optimisticRefined}
        onChange={handleChange}
        label={<Text16 bold>{formatMessage(FILTER.label)}</Text16>}
      />
    </Toggle>
  );
};

export const MyAuctions: FilterWidget = {
  key: FILTER.attribute,
  type: 'toggle',
  attribute: FILTER.attribute,
  Component: () => <Filter />,
};

export default MyAuctions;
